module.exports = ".info-box {\n  padding: 1px 5px;\n  background-color: #428bca;\n  float: right !important; }\n"